
import React, { useEffect, useState } from "react";
import { useObjCommonFilterStore } from "../../../hooks/objCommonFilter";
import { useAdminCommonStore } from "src/hooks/admin/adminCommon";
import Helper from "src/helper/Helper";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import "react-datepicker/dist/react-datepicker.css";
import { DateRangePicker } from 'rsuite';
import { profileStore } from 'src/hooks/profile';
import { useDOMAttachToSystemStore } from "src/hooks/domAttachToSystem";
import moment from "moment";

export function SearchAcct() {
  const [{ orgList }, { get_organization_detail }, { }] = useAdminCommonStore();
  const defaultModel = {
    accountName: "",
    accountNumber: "",
    salesOrg: [],
    isAccountActive: "",
    country: [],
    createdDate: ""
  };
  const [searchData, setSearchData] = useState(defaultModel);
  const [{ filter_list }, { }, { set_filter_list }] = useObjCommonFilterStore();

  const [{ }, { system_alert_indicator, clear_all_system_alert }, { }] = useDOMAttachToSystemStore();
  const [{ countryList }, { get_country_list }, { }] = profileStore();

  useEffect(() => {
    async function fetchHere() {
      get_organization_detail();
      await get_country_list()
    }

    fetchHere();
  }, []);


  useEffect(() => {
    if (!filter_list || Object.entries(filter_list).length === 0) {
      setSearchData(defaultModel);
    } else {
      const searchingData = defaultModel;
      searchingData.accountName = filter_list?.accountName?.searchKeyword ? filter_list?.accountName?.searchKeyword : '';
      searchingData.accountNumber = filter_list?.accountNumber?.searchKeyword ? filter_list?.accountNumber?.searchKeyword : '';
      searchingData.salesOrg = filter_list?.salesOrg?.searchKeywordArr ? filter_list?.salesOrg?.searchKeywordArr : [];
      searchingData.isAccountActive = filter_list?.isAccountActive?.searchKeyword ? filter_list?.isAccountActive?.searchKeyword : '';
      searchingData.country = filter_list?.country?.searchKeywordArr ? filter_list?.country?.searchKeywordArr : [];
      searchingData.createdDate = filter_list?.createdDate?.searchKeywordArr ? filter_list?.createdDate?.searchKeywordArr : null;
      setSearchData(searchingData);
    }
  }, [filter_list]);

  const onSearch = (e) => {
    e.preventDefault();

    const isSearchDataEmpty = Object.values(searchData).every(
      (value) => !value
    );

    if (isSearchDataEmpty) {

      system_alert_indicator({
        name: "adminconsole",
        message: "At least one of the fields (Account Name or Account Number) should have search keywords to display results",
        type: "danger",
        isDisplayIcon: true,
        isDisplay: false
      });

      return;
    }

    const keyToSearchType = {
      accountName: "Account Name",
      accountNumber: "Account Number",
      salesOrg: "Sales Org",
      isAccountActive: "Account Active",
      createdDate: "Created Date",
      country: "Country"
    };
    const filterList = Object.entries(searchData)
      .filter(([key, value]) => Helper.valueIsNotNull(value)).map((v) => {
        return {
          searchType: keyToSearchType[v[0]],
          key: v[0],
          [Array.isArray(v[1]) ? 'searchKeywordArr' : 'searchKeyword']: typeof v[1] === 'string' ? v[1].trim() : v[1],
        };
      });

    const filterListObject = filterList?.reduce((acc, curr) => {
      acc[curr.key] = curr;
      return acc;
    }, {});
    if (!Helper.valueIsNotNull(searchData?.accountNumber)) {
      system_alert_indicator({
        name: "adminconsole",
        message: "Please enter Account Number",
        type: "danger",
        isDisplayIcon: true,
        isDisplay: false
      });

      return;
    }
    const accountNumberLength = searchData?.accountNumber?.length;
    if (accountNumberLength && accountNumberLength < 2) {

      system_alert_indicator({
        name: "adminconsole",
        message: "Enter at least 2 characters without zero",
        type: "danger",
        isDisplayIcon: true,
        isDisplay: false
      });
      return;
    }

    if (filterListObject.hasOwnProperty('accountNumber')) {
      if (!/^(?!0+$)[0-9]+$/.test(filterListObject.accountNumber.searchKeyword)) {

        system_alert_indicator({
          name: "adminconsole",
          message: "Enter keyword greater than zero",
          type: "danger",
          isDisplayIcon: true,
          isDisplay: false
        });
        return;
      }
    }
    clear_all_system_alert({});
    set_filter_list(filterListObject);
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "accountNumber") {
      const truncatedValue = value.slice(0, 10); // Limit to 10 digits
      setSearchData((prevData) => ({
        ...prevData,
        [name]: truncatedValue
      }));
    } else {
      setSearchData((prevData) => ({
        ...prevData,
        [name]: value
      }));
    }
  };
  return (
    <>
      <div className="bg-grey2">
        <div className="container">
          <div className="accordion-item ">
            <h2 className="accordion-header" id="searchInput">
              <button
                className="accordion-button"
                type="button"
                data-toggle="collapse"
                data-target="#collapseSearch"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                <b className="font-16">Search</b>
              </button>
            </h2>

            <div
              id="collapseSearch"
              className="accordion-collapse collapse in"
              aria-labelledby="searchInput"
              data-parent="#accordionExample"
            >
              <div className="accordion-body p-0">
                <form
                  onSubmit={(e) => {
                    onSearch(e);
                  }}
                >
                  <div className="row bs5 m-t-30 ms-0 me-0 usersearch-container">
                    <div className="col-sm-12 col-md-3 mb-2">
                      <label htmlFor="accountName">Account Name </label>
                      <input
                        className="ps-2 form-control form-control-sm mb-0"
                        name="accountName"
                        placeholder="Account Name"
                        type="text"
                        value={searchData.accountName}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="col-sm-12 col-md-3 mb-2">
                      <label htmlFor="accountNumber">Account Number* </label>
                      <input
                        className="ps-2 form-control form-control-sm mb-0 hidearrow"
                        name="accountNumber"
                        placeholder="Account Number"
                        type="number"
                        onKeyDown={event => ['e', 'E', '+', '-', '.']?.includes(event.key) && event.preventDefault()}
                        value={searchData.accountNumber}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="col-sm-12 col-md-3 mb-2 multiselect">
                      <label htmlFor="salesOrg">Sales Org </label>
                      <ReactMultiSelectCheckboxes
                        placeholderButtonLabel="Select Sales Org"
                        style={{ minWidth: "300px" }}
                        value={searchData.salesOrg}
                        options={
                          orgList &&
                          orgList?.length > 0 ?
                          orgList?.map((option) => ({
                            value: option,
                            label: option,
                          })) : []
                        }
                        onChange={(selectedOptions) => {
                          handleInputChange({
                            target: {
                              name: "salesOrg",
                              value: selectedOptions,
                            },
                          });
                        }}
                      />
                    </div>

                    <div className="col-sm-12 col-md-3 mb-2">
                      <label htmlFor="isAccountActive">
                        Is Account Active?{" "}
                      </label>
                      <div className="selectbox">
                        <select
                          className="form-control form-control-sm"
                          name="isAccountActive"
                          value={searchData.isAccountActive}
                          onChange={handleInputChange}
                          defaultValue={""}
                        >
                          <option value={""}>Select Yes/No</option>
                          <option value={"Yes"}>Yes</option>
                          <option value={"No"}>No</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-3 mb-2 multiselect">
                      <label htmlFor="country">Country </label>
                      <ReactMultiSelectCheckboxes
                        placeholderButtonLabel="Select Country"
                        style={{ minWidth: "300px" }}
                        value={searchData.country}
                        options={countryList && countryList.length > 0 &&
                          countryList.map(option => ({ value: option.countryCode, label: option.countryName }))}
                        onChange={(selectedOptions) => {
                          handleInputChange({
                            target: {
                              name: "country",
                              value: selectedOptions,
                            },
                          });
                        }}
                      />
                    </div>
                    <div className="col-sm-12 col-md-3 mb-2">
                      <label htmlFor="createdDate">Created Date </label>
                      <DateRangePicker
                        format={Helper.getDatepickerFormat()}
                        placeholder="Month DD, YYYY"
                        character=" – "
                        cleanable={false}
                        editable={false}
                        value={searchData?.createdDate ? searchData?.createdDate[0].value?.split(';')?.map(isoDate => new Date(isoDate)) : null}
                        onChange={dates => {
                          if (dates?.length === 2) {
                            handleInputChange({
                              target: {
                                name: "createdDate",
                                value: [{
                                  label: dates.map(date => moment(date).format("MMMM DD, yyyy"))?.join(' - '),
                                  value: dates.map(date => moment(date).format('YYYY-MM-DD'))?.join(';')
                                }]
                              }
                            })
                          }
                        }}
                      />
                    </div>
                  </div>

                  <div className="row bs5 m-t-20">
                    <div className="col-sm-12 text-sm-end">
                      <button className="btn btn-secondary bs5">Search</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
